import { Injectable } from '@angular/core';
import { FiBackendService } from '@fi-shared/fi-backend/fi-backend.service';
import { WidgetAdministrateModel } from './model/widget-administrate.model';
import { WidgetPlaceHolderControlModel } from '@fi-shared/widget/widget-place-holder-control.model';
import { WidgetLayoutService } from '@fi-shared/widget/widget-layout.service';
import { Subject } from 'rxjs';
import { cloneDeep } from '@fi-shared/utils';
import { WidgetModel } from '@fi-app/widget/model/widget.model';
import { ModuleType } from '@fi-shared/types';
import { FiUserDataService } from '@fi-shared/fi-shared-services/fi-user-data.service';

interface IWidgetAdministrateRequestArgs {
    isEditMode?: boolean;
    siteDesignId?: number;
}

@Injectable()
export class WidgetAdministrateService {
    previewImageGenerated$ = new Subject<void>();

    constructor(
        private fiBackend: FiBackendService,
        private widgetLayoutService: WidgetLayoutService,
        private userDataService: FiUserDataService,
    ) {}

    private getWidgetAdministrates(args: IWidgetAdministrateRequestArgs) {
        const widgetAdministrates: WidgetAdministrateModel[] = [];

        const promise = new Promise<WidgetAdministrateModel[]>((resolve, reject) => {
            let url = `Widget/Widget/GetWidgetAdministrates/${!args.isEditMode}?siteDesignId=${args.siteDesignId}`;

            /*let url2 = `api2/Widget/GetWidgetAdministrates`; // todo for flutter app tests
            this.fiBackend.fetchData<any[]>(url2).then(data => {
                console.log('api2 widgets', data);
            })*/

            this.fiBackend.fetchData<any[]>(url).then((data) => {
                data.forEach((widgetAdministrateData) => {
                    widgetAdministrates.push(
                        new WidgetAdministrateModel(this.widgetLayoutService, widgetAdministrateData),
                    );
                });
                resolve(widgetAdministrates);
            }, reject);
        });

        return promise;
    }

    getWidgetAdministrateForModule(
        moduleType: ModuleType,
        args?: IWidgetAdministrateRequestArgs,
    ): Promise<WidgetAdministrateModel> {
        if (!args) {
            args = {};
        }
        if (!args.siteDesignId) {
            args.siteDesignId = this.userDataService.getActiveSiteDesignId();
        }

        const promise = new Promise<WidgetAdministrateModel>((resolve, reject) => {
            this.getWidgetAdministrates(args).then((widgetAdministrates) => {
                const existingWidgetAdministrate = widgetAdministrates.find(
                    (widgetAdministrate) => widgetAdministrate.ModuleType === moduleType,
                );
                if (existingWidgetAdministrate) {
                    resolve(existingWidgetAdministrate);
                } else {
                    // create new administrate object in case existing one does not found
                    let newWidgetAdministrateModel = new WidgetAdministrateModel(this.widgetLayoutService);
                    newWidgetAdministrateModel.ModuleType = moduleType;
                    newWidgetAdministrateModel.SiteDesignId = args.siteDesignId;
                    resolve(newWidgetAdministrateModel);
                }
            }, reject);
        });

        return promise;
    }

    InitAdministrateWidgetDefaultLayout(administrateWidget: WidgetAdministrateModel, widgets: WidgetModel[]) {
        administrateWidget.BaseUrl = this.widgetLayoutService.getDefaultLayout().Id;
        administrateWidget.UpdatePlaceHolderCollection(
            this.widgetLayoutService.getLayoutById(administrateWidget.BaseUrl),
        );

        // find default newsfeed widget
        let newsfeedWidgetId: number;

        widgets.forEach(function (widget) {
            if (widget.Settings.Name == 'NewsFeed') {
                newsfeedWidgetId = widget.Id;
            }
        });
        if (newsfeedWidgetId) {
            administrateWidget.FindPlaceholderByNumber(1).ControlCollection.push(
                new WidgetPlaceHolderControlModel({
                    WidgetId: newsfeedWidgetId,
                }),
            );
        }
    }

    BuildWidgetAdministrateWidgetsList(WidgetAdministrate: WidgetAdministrateModel, Widgets: any[]) {
        var result = {};
        WidgetAdministrate.PlaceHolderCollection.forEach(function (PlaceHolder) {
            PlaceHolder.ControlCollection.forEach(function (Control) {
                var filteredWidgets = Widgets.filter((widget) => widget.Id === Control.WidgetId);
                if (filteredWidgets.length > 0) {
                    result[Control.ccmInternalId] = filteredWidgets[0];
                }
            });
        });
        return result;
    }

    SaveWidgetAdministrate(WidgetAdministrate: WidgetAdministrateModel) {
        var data: WidgetAdministrateModel = cloneDeep(WidgetAdministrate);
        data.PlaceHolderCollection.forEach(function (PlaceHolder) {
            PlaceHolder.Properties = JSON.stringify(PlaceHolder.Properties);
            var SortOrder = 0;
            PlaceHolder.ControlCollection.forEach(function (Control) {
                Control.SortOrder = SortOrder;
                Control.Settings = <any>JSON.stringify(Control.Settings);
                delete Control.ccmInternalId;
                SortOrder++;
            });
        });

        return this.fiBackend.fetchDataPost<number>('Widget/Widget/SaveWidgetAdministrate', data);
    }

    /*GetWidgetAdministrate(Id: number) { // todo not used?
        return this.fiBackend.fetchData(`Widget/Widget/GetWidgetAdministrate/${Id}`);
    }*/
}
